import { useContext } from "react";
import { Paper, Grid, Typography, Avatar, Box } from "@mui/material";
import {
  verificationContext,
  ContextType,
} from "../context/VerificationContext";
import moment from "moment";
import { calculateAge } from "../../../utilis/methods/dateMethods";
import { getPatientGroupingDisplay } from "../../../utilis/methods/patientGrouping";
import { EmrContext } from "../../../EMR";
import DetailsSkeleton from "../../../utilis/component/DetailsSkeleton";
import PatientVipChip from "../../../utilis/component/PatientVipChip";
// import useAuthentication from "@hooks/useAuthentication";

function DetailsCard() {

  const { searchData } = useContext(verificationContext) as ContextType;
  const {dataLoading} = useContext(EmrContext)
  const checkDateFormat = (date: string): string | null => {
    const formats = ["DD/MM/YYYY", "DD-MM-YYYY", "YYYY/MM/DD", "YYYY-MM-DD"];

    for (let format of formats) {
      if (moment(date, format, true).isValid()) {
        return format;
      }
    }
    return null;
  };
  const showAge = (dob: string): string => {
    const format = checkDateFormat(dob);
    if (dob) {
      if (format) {
        const age = calculateAge(moment(dob, format).format("YYYY-MM-DD"));
        const ageTypeKey =
          age.age > 1
            ? age.ageType
            : (`${age.ageType}1` as keyof typeof dateType);
        return `${age.age} ${dateType[ageTypeKey]}`;
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  // const{user}= useAuthentication();
//  const regionValue= user?.region;
//    const idHeading =
//  regionValue === "QATAR_REGION"
//    ? "Qatar ID"
//    : "Emirates Id";
const idHeading = "Civil ID"

  return Boolean(searchData && !dataLoading) ? (
    <Paper
      elevation={3}
      sx={{
        padding: 3,
        borderRadius: 2,
        maxWidth: "100%",
        overflow: "hidden",
      }}
    >
      <Grid container spacing={1}>
        {/* Row 1 */}
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Name
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                  {`${searchData?.pmaster?.patientName || ""}`}
                </Typography>
                <PatientVipChip isVip={searchData?.pmaster?.isVip} />
              </Box>
            </Grid>

            <Grid item xs={3}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Doctor
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {searchData?.encounter?.doctorName || ""}
              </Typography>
            </Grid>

            <Grid item xs={4}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Payer
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {searchData?.insurancePatient?.inGroup_name ||
                  searchData?.insurancePatient?.insurance_name ||
                  ""}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Age
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {showAge(searchData?.pmaster?.dob as string) || ""}
              </Typography>
            </Grid>
            <Grid
              item
              xs={2}
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{ position: "relative" }}
            >
              <Avatar
                sx={{
                  width: 100,
                  height: 100,
                  backgroundColor: "grey.300",
                  color: "text.secondary",
                  fontSize: "1.5rem",
                  position: "absolute",
                  top: "40px",
                }}
                src={searchData?.image || ""}
              >{searchData?.pmaster?.patientName[0]?.toUpperCase()||""} {searchData?.pmaster?.lastName[0]?.toUpperCase() || ""}</Avatar>
            </Grid>
          </Grid>
        </Grid>

        {/* Row 2 */}
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Gender
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {searchData?.pmaster?.gender || ""}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Department
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {searchData?.encounter?.departmentName || ""}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Plan
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {searchData?.insurancePatient?.inPlan_name || ""}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Card No
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {searchData?.insurancePatient?.cardNo || ""}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        {/* Row 3 */}
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Mobile
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {searchData?.amaster?.mobileNo || ""}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                {idHeading}
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {searchData?.pmaster?.emiratesId || searchData?.pmaster?.passportNum || searchData?.pmaster?.gccId }
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Receiver
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {searchData?.insurancePatient?.insurance_name || ""}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                From Date
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {searchData?.insurancePatient?.policyValidityFrom || ""}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ fontWeight: "bold" }}
              >
                Grouping
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                {getPatientGroupingDisplay(searchData) || "-"}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  ) : (
    <DetailsSkeleton count={16}/>
  );
}

export default DetailsCard;

const dateType = {
  D: "Days",
  Y: "years",
  M: "Months",
  D1: "Day",
  Y1: "years",
  M1: "Months",
};
